import * as EVCoreDefaultComponents from '@uswitch/ev-components/lib/components/defaults/components'

import categoryGuidesModule from './category-guides-module'
import { collectionModule } from './collection'
import broadbandDealGroup from './deal-group'
import { providersLogoModule } from './providers-logo-module'
import { reviews } from './reviews/wrapper'
import { subNavigationModule } from './sub-navigation/wrapper'
import widgetHtml from './widget-html'

import component from '.'

const ComponentMap = {
  ...EVCoreDefaultComponents,
  broadbandDealGroup,
  widgetHtml,
  categoryGuidesModule,
  subNavigationModule,
  reviews,
  collectionModule,
  providersLogoModule,
  component
}

export default ComponentMap
